import { REFI_WEB_UI_CONST } from '../../constants/constants.js';

class _StorageService {
  localStorageKeys = {};

  setStorage(storage) {
    localStorage.setItem(REFI_WEB_UI_CONST.localStorageKey, JSON.stringify(storage));
  }

  getStorage() {
    const storage = localStorage.getItem(REFI_WEB_UI_CONST.localStorageKey);
    return storage ? JSON.parse(storage) : {};
  }

  setProp(name, value) {
    const storage = this.getStorage();
    storage[name] = value;
    this.setStorage(storage);
  }

  getProp(name) {
    const storage = this.getStorage();
    return storage[name];
  }

  preserveLocalStorage() {
    REFI_WEB_UI_CONST.WRAP_UP_MFE_LOCAL_STORAGE_KEYS.forEach(key => {
      const value = localStorage.getItem(key);
      if (value) {
        this.localStorageKeys[key] = value;
      }
    });
  }

  restoreLocalStorage() {
    Object.entries(this.localStorageKeys).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
  }

  clearStorage() {
    this.preserveLocalStorage();
    localStorage.clear();
    this.restoreLocalStorage();
  }

  getStsBypass() {
    return localStorage.getItem(REFI_WEB_UI_CONST.successfulStsBypass);
  }

  setStsBypass(flag) {
    localStorage.setItem(REFI_WEB_UI_CONST.successfulStsBypass, flag);
  }

  getShowOfferBanner() {
    return localStorage.getItem(REFI_WEB_UI_CONST.offerBanner);
  }

  setShowOfferBannerInSession(externalId) {
    localStorage.setItem(REFI_WEB_UI_CONST.offerBanner, externalId);
  }
}

export const StorageService = new _StorageService();
